var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{attrs:{"title":_vm.$t('message.hero.confirmIdTitle')}}),(_vm.isAVRMobile && _vm.disclaimerText)?_c('p',[_vm._v("\n    "+_vm._s(_vm.disclaimerText)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }